<template>
  <div>
    <p class="text-2xl mb-6">
      Exports
    </p>

    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-3">
        <v-col cols="12">
          <filters></filters>
        </v-col>
      </v-row>
    </v-card>

    <progress-bar :download="download" />
  </div>
</template>

<script>
import { computed, reactive, watch } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

import ProgressBar, {
  download_initial_state,
  resetDownload,
} from "@/components/common/ProgressBar";


import Filters from "@/components/admin/exports/filters/Filters";


export default {
  name: "Exports",
  components: {
    Filters,
    ProgressBar,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const page = reactive({
      loading: false,
    });
    const download = reactive(download_initial_state());

    // =>  METHODS
    const exportExcel = async () => {
      if (
        !startDate.value ||
        startDate.value.length !== 10 ||
        !endDate.value ||
        endDate.value.length !== 10
      ) {
        alert("Sélectionnez une plage de date !");
        return false;
      }

      if (!exportName.value) {
        alert("Sélectionnez un export !");
        return false;
      }

      if (!applyFilters.value || page.loading) {
        return;
      }

      page.loading = true;
      download.running = true;

      try {
        const { data } = await axiosGet(
          "/admin/extracts/export_csv",
          {
            start_date: startDate.value,
            end_date: endDate.value,
            export_name: exportName.value,
          },
          {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              download.percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          }
        );

        // Start download:
        const downloadLink = document.createElement("a");
        const blob = new Blob(["\ufeff", data]);
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = `${exportName.value}_${startDate.value}_${endDate.value}.csv`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        console.error("error while fetching data");
        resetDownload(download);
      }

      page.loading = false;

      // Force clicking on button again to re-run that request :
      // (we don't call this dispatch earlier to be sure, as state is async, that all listening components could run their requests)
      store.dispatch("common/updateApplyFilters", false);
    };

    // =>  COMPUTED
    const applyFilters = computed(
      () => store.getters["common/getApplyFilters"]
    );
    const startDate = computed(() => store.getters["admin/getDates"][0]);
    const endDate = computed(() => store.getters["admin/getDates"][1]);
    const exportName = computed(() => store.getters["admin/getExport"]);

    // =>  WATCH
    watch(applyFilters, () => {
      exportExcel();
    });

    watch(
      () => download.percentCompleted,
      (newValue) => {
        if (newValue >= 100) {
          setTimeout(() => {
            resetDownload(download);
          }, 500);
        }
      }
    );

    // =>  HOOKS

    // =>  DATA
    return {
      download,
    };
  },
};
</script>

<style scoped></style>
